import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
import messages from '../../redux/messages';
import gestorDocumentalServices from '../gestorDocumental/gestorDocumental.services';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getEmpChecklist = (userId, itype) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EMP_CHECKLIST,
      payload: true
    });
    
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.get( itype  === 1 ? `/api/app/Formal_Empleado_Check_List/` : `/api/app/Funcional_Empleado_Check_List/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      },
      params: {filter: userId}
    });
    
    dispatch({
      type: actions.GET_EMP_CHECKLIST,
      payload: resp.data.data
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else if(ex.response.status !== 404){
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_EMP_CHECKLIST,
      payload: false
    });
  }
}

export const saveCheckListEmployee = (data, itype) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_EMP_CHECKLIST,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.post(itype === 1 ? `/api/app/Formal_Empleado_Check_List/`: '/api/app/Funcional_Empleado_Check_List/', data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }});
    const { checklistEmp } = getState().employeeDocsCheckList;
    const aCheckListEmployee = [...checklistEmp, resp.data];
    dispatch({
      type: actions.GET_EMP_CHECKLIST,
      payload: aCheckListEmployee
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.SAVE_LOADER_EMP_CHECKLIST,
      payload: false
    });
  }
}

export const editCheckListEmployee = (data, itype, index, id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_EMP_CHECKLIST,
      payload: true
    });
    //  
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.put(itype === 1 ? `/api/app/Formal_Empleado_Check_List/${id}/`: `/api/app/Funcional_Empleado_Check_List/${id}/`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }});
     
    const { checklistEmp } = getState().employeeDocsCheckList;
    checklistEmp[index] = resp.data;
    //const aCheck = [...checklist, resp.data];
    dispatch({
      type: actions.GET_EMP_CHECKLIST,
      payload: checklistEmp
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.SAVE_LOADER_EMP_CHECKLIST,
      payload: false
    });
  }
}

export const deleteCheckListEmployee = (id, index, itype) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EMP_CHECKLIST,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    await client.delete(itype === 1 ? `/api/app/Formal_Empleado_Check_List/${id}/`: `/api/app/Funcional_Empleado_Check_List/${id}/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
    }});
     
    const { checklistEmp } = getState().employeeDocsCheckList;
    checklistEmp.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_EMP_CHECKLIST,
      payload: checklistEmp
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_EMP_CHECKLIST,
      payload: false
    });
  }
}

export const saveCheckListDocGD = (dataGD, editItem, index, iType, exist) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EMP_CHECKLIST,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const { checklistEmp } = getState().employeeDocsCheckList;
    if(exist){
      const respGD = await gestorDocumentalServices.saveDocument(dataGD);
      const respPUTRel = await client.put(iType === 1 ? `/api/app/Formal_Empleado_Check_List/${editItem.id}/` : `/api/app/Funcional_Empleado_Check_List/${editItem.id}/`, {
        ...dataGD,
        archivos_gestor: respGD.data.resultado.id,
        activo: true
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`
        }});
      checklistEmp[index] = respPUTRel.data;
      dispatch({
        type: actions.GET_EMP_CHECKLIST,
        payload: checklistEmp
      });
    }else{
      dispatch({
        type: actions.GET_EMP_CHECKLIST,
        payload: {
          checklistEmp: checklistEmp
        }
      });
    }
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_EMP_CHECKLIST,
      payload: false
    });
  }
}

export const editCheckListDocGD = (dataGD, editItem, index, iType, arGD, exist) => async (dispatch, getState) => {
  try {
    debugger
    dispatch({
      type: actions.LOADING_EMP_CHECKLIST,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const { checklistEmp } = getState().employeeDocsCheckList;
    if(exist){
      const respGD = await gestorDocumentalServices.editDocument(arGD, dataGD);
      const respPUTRel = await client.put(iType === 1 ? `/api/app/Formal_Empleado_Check_List/${editItem.id}/` : `/api/app/Funcional_Empleado_Check_List/${editItem.id}/`, {
        ...editItem,
        archivos_gestor: respGD.data.id,
        activo: true
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`
        }});
      checklistEmp[index] = respPUTRel.data;
      dispatch({
        type: actions.GET_EMP_CHECKLIST,
        payload: checklistEmp
      });
      toastr.success(messages.successMessage);
    }else{
      dispatch({
        type: actions.GET_EMP_CHECKLIST,
        payload: {
          checklistEmp: checklistEmp
        }
      });
    }
    // const { checklistEmp } = getState().employeeDocsCheckList;
    // try{
    //   const respGD = await gestorDocumentalServices.editDocument(parseInt(id), data);
    //   const respuestGD = respGD.data;
    //   editItem.archivos_gestor = respuestGD;
    //   editItem.archivo_gestor = respuestGD.id;

    //   checklistEmp[index] = editItem;
    //   dispatch({
    //     type: actions.GET_EMP_CHECKLIST,
    //     payload: checklistEmp
    //   });
    //   toastr.success(messages.successMessage);
    // } catch (error) {
    //   console.log(error);
    // }
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_EMP_CHECKLIST,
      payload: false
    });
  }
}